import { render, staticRenderFns } from "./myDetail.vue?vue&type=template&id=0a2931bb&scoped=true"
import script from "./myDetail.vue?vue&type=script&lang=js"
export * from "./myDetail.vue?vue&type=script&lang=js"
import style0 from "./myDetail.vue?vue&type=style&index=0&id=0a2931bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2931bb",
  null
  
)

export default component.exports